import { useMemo } from "react";

import { State } from "../../types";

export const useExtractNonGroupValues = (key: string, multiple: boolean, values: State["values"]) =>
  useMemo((): Array<string> => {
    let filterFunction = (k: string) => k.toLocaleLowerCase() === key.toLocaleLowerCase();
    if (multiple) {
      filterFunction = (k: string) => k.toLocaleLowerCase().startsWith(`${key.toLocaleLowerCase()}.`);
    }
    return Object.keys(values).filter(filterFunction);
  }, [key, multiple, values]);
